import React, {useMemo} from 'react';

import cs from 'classnames';
import {withRouter, WithRouterProps} from 'react-router';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

import {applyFilter} from './DashboardFilterbar';

interface OwnProps {
  template_at: null | string;
}

type Props = WithRouterProps & OwnProps;

export const DocIsTemplateBadge = withRouter(
  ({template_at, router, location}: Props) => {
    if (template_at == null) {
      return null;
    }

    const currentFilters: Array<string> = useMemo(() => {
      return location.query?.filter?.split(',') ?? [];
    }, [location.query.filter]);

    const isActive = currentFilters.includes('is_template');

    function applyTemplateFilter() {
      const updatedFilters = isActive
        ? currentFilters.filter((f) => f !== 'is_template')
        : [...currentFilters, 'is_template'];
      applyFilter(router, location, {filter: updatedFilters.join(',')});
    }

    return (
      <LazyTooltip tooltip={gt('This document is a template')}>
        <button
          className={cs('btn', 'ml-1', 'badge', {
            'badge-secondary': isActive,
            'badge-light': !isActive,
          })}
          onClick={applyTemplateFilter}
        >
          <i className="fa fa-file-export" /> {gt('Template')}
        </button>
      </LazyTooltip>
    );
  }
);
